import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService, Product } from '@spartacus/core';

interface CustomProductReferences {
  currentPage: number;
  products: Product[];
  totalPageCount: number;
  totalProductCount: number;
}

@Injectable({
  providedIn: 'root'
})
export class CustomProductReferencesService {
  load(
    productCode: string,
  ){
    return this.http
      .get<CustomProductReferences>(this.getEndpoint(productCode))
  }

  getEndpoint(
    code: string,
    reference?: string,
  ): string {
    return this.occEndpoints.buildUrl('productReferences', {
      urlParams: { productCode: code },
      queryParams: { reference },
    });
  }

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
  ) {}
}
